import React from "react"
import { connectStats } from "react-instantsearch-dom"

export const FocussedHitsCount = connectStats(({ nbHits }) => (
  <div className="level-item hit-count">
    insgesamt {nbHits.toLocaleString()}
  </div>
))
